<div class="container-fluid" >
    <div class="card shadow">
      <div class="card-header d-flex justify-content-between">
        <h4 class="font-weight-bold text-dark py">ADDTIONAL POST REQUEST APPROVAL</h4>
      </div>
    <div *ngIf="!tableshow" class="d-flex justify-content-center">
      <div  class="loader"></div>
    </div>
        
 <!--DATATABLE         -->
  <div class="card-body">
    <div class="table-responsive" *ngIf="tableshow">
        <!-- TABLE -->
            <table class="table table-bordered display" [dtOptions]="dtOptions" datatable width="100%" cellspacing="0">
              <thead>
                <tr>
                    <th>District</th>
                    <th>Requested Additional Role</th>
                    <th>Approval Status</th>
                    <th>Request Date</th>
                    <!-- <th>Comments</th> -->
                    <th>Approve</th>
                    <th>Reject</th>
                </tr>
              </thead>
  
              <tbody>
                <tr *ngFor="let customer of customers">
                    <td style="min-width: 20px;">
                      {{customer.district}}
                    </td>
                    <td style="min-width: 20px;">
                      {{customer.applied_role}}
                    </td>
                    <td style="min-width: 20px;">
                      {{customer.approval}}
                    </td>
                    <td style="min-width: 20px;">
                      {{customer.date}}
                    </td>
                    <!-- <td style="min-width: 20px;">
                      {{customer.reason}}
                    </td> -->
                    <td><a  class="btn btn-info btn-circle btn-sm" (click)="approve_role_change(customer.user_maser_id,'approve')">
                        <i class="fas fa-check"></i>
                    </a></td>
                    <td><a  class="btn btn-danger btn-circle btn-sm" (click)="approve_role_change(customer.user_maser_id,'reject')" >
                        <i class="fas fa-ban"></i>
                    </a></td>
                  </tr>
              </tbody>
              
            </table>
    </div>
  </div>
    
  </div>
  
  </div>